import { DEFAULT_ERROR_MESSAGE, useErrorStore } from '@/stores/errorStore'
import type { App } from 'vue'

export default function (app: App) {
  app.config.errorHandler = (err: any) => {
    const errorStore = useErrorStore()
    errorStore.addError(err.message ?? DEFAULT_ERROR_MESSAGE)
  }
}
